module.exports = __webpack_public_path__ + "img/premiere.bf5999b3.png";